import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../axios.js';

const fetchEventTypes = async (deviceId: string): Promise<string[]> => {
  const { data } = await apiClient.get<string[]>(`/devices/${deviceId}/event-types`);
  return data;
};

export const useEventTypes = (deviceId: string) => {
  return useQuery({
    queryKey: ['device-event-types', deviceId],
    queryFn: () => fetchEventTypes(deviceId),
    enabled: Boolean(deviceId),
    staleTime: Infinity,
  });
};
